import { render } from "./EditorForm.vue?vue&type=template&id=052643d2"
import script from "./EditorForm.vue?vue&type=script&lang=js"
export * from "./EditorForm.vue?vue&type=script&lang=js"
script.render = render

export default script